// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"Q3-z","displaySixCardTiles":"R3-z"};